// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vkNZ6bhU49AQzmDih23s{display:flex;flex-direction:row;justify-content:flex-start;align-items:center;text-decoration:none;color:#5b6473;font-size:13px;font-weight:500;line-height:1.1;width:80%;margin-top:20px;margin-bottom:18px}@media(min-width: 768px){.vkNZ6bhU49AQzmDih23s{font-size:14px;margin-top:22px;margin-bottom:20px}}.vkNZ6bhU49AQzmDih23s img{margin-right:12px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"breadcrumb": "vkNZ6bhU49AQzmDih23s"
};
export default ___CSS_LOADER_EXPORT___;
